import ptMessages from './ptMessages';
import esMessages from './esMessages';
import enMessages from './enMessages';

const messages = (locale) => {
  switch (locale) {
    case 'pt':
      return ptMessages;
    case 'es':
      return esMessages;
    case 'en':
      return enMessages;
    default:
      return enMessages;
  }
};

export default messages;



/** WEBPACK FOOTER **
 ** ./src/intl/index.js
 **/